export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 1_04.a23838d6.jpg";